import React from "react";
import "../../Assets/styles/Timeline.css";

const TimelineSection = () => {
  return (
    <section className="timeline-section" id="timeline">
      <div className="timeline-content">

        <h2 className="timeline-title">
          A nossa história
        </h2>
        
        <br/>
        <br/>

        <p className="timeline-text">
        Namoramos há cinco anos e em junho de 2024 ficámos noivos e começámos a preparar aquele que será um dos dias mais felizes das nossas vidas. <br/><br/>
        Foi através de amigos em comum que nos conhecemos num jantar de verão em 2019, e dois anos depois, nunca mais nos largámos. Durante estes anos, temos tido a sorte de partilhar momentos incríveis com as nossas famílias e amigos, viagens, treinos e  muitos desafios. 
        Complementamo-nos, divertimo-nos imenso juntos e temos aprendido muito um com o outro. Em 2023, decidimos adoptar a nossa cadela Benny, que veio consolidar a nossa família e trazer muito amor e energia à nossa casa.<br/> <br/>
        Estamos muito entusiasmados para partilhar o dia do nosso casamento convosco. Aqui vão encontrar todas as informações de que precisam para este dia especial, esperamos que desfrutem ao máximo! <br/><br/>
        Beijinhos,
        <br/>
        Margarida e Diogo
        </p>

      </div>
    </section>
  );
};

export default TimelineSection;